import { ComponentType } from 'react';
import { GameHeader, PromosHeader } from './custom-headers';

export const RouteHeaderComponents: Record<
  string,
  ComponentType<{ onBackPress: () => void }>
> = {
  '/games/launch/:any/:any?': GameHeader,
  '/promos': PromosHeader,
  // '/verifyInteracEmail': null,
  // '/shop': ShopHeader,
  // '/register': RegistrationHeader,
};

export const CustomRouteHeaderPaths = Object.keys(RouteHeaderComponents).map(
  (path) => ({ path }),
);

export const DisableBackButtonRoutes = ['/verifyInteracEmail'].map((route) => ({
  path: route,
}));
